import Fuse from 'fuse.js'

interface Props<T> {
  data: T[]
  keysToSearch: string[]
  query: string
}

export function useSearch<T>({ keysToSearch, data, query }: Props<T>) {
  const options = { keys: keysToSearch ?? [], includeScore: true }
  const fuse = new Fuse(data, options)
  const searchResults = fuse.search(query).map((r) => r.item)
  return { searchResults }
}
